import React from "react";
import RemoveButton from "./RemoveButton";

/** Props for RowItem */
interface RowItemProps {
	/** The index of this row (for display, e.g., Row #1) */
	index: number;
	/** Whether to show the "Remove" button */
	showRemoveButton?: boolean;
	/** Handler for removing this row, if applicable */
	onRemove?: (index: number) => void;
	/** Child elements - the form fields or anything else you want in the row */
	children: React.ReactNode;
}

/**
 * RowItem displays a title ("Material Row X"), optionally a remove button,
 * and any children you pass in (the form fields, dropdowns, etc.).
 */
const RowItem: React.FC<RowItemProps> = ({
											 index,
											 showRemoveButton = false,
											 onRemove,
											 children,
										 }) => {
	return (
		<div className="row-item">
			{/* Header + Optional Remove Button */}
			<div className="flex justify-between items-center">
				<h3 className="row-header">Material Row {index + 1}</h3>
				{showRemoveButton && onRemove && (
					<RemoveButton
						onRemove={() => onRemove(index)}
					></RemoveButton>
				)}
			</div>

			{/* Render whatever form fields or other UI come as children */}
			{children}
		</div>
	);
};

export default RowItem;